// extracted by mini-css-extract-plugin
module.exports = {"ocManagment":"styles_ocManagment___zu4b","margin":"styles_margin__2oqMV","tableContainer":"styles_tableContainer__UkB4y","topModule":"styles_topModule__3K9BV"};